import { motion } from "framer-motion";
import { ReactNode } from "react";

type ModelFramerProps = {
  children: ReactNode; // Optional children prop
  className : string;
}

export default function ModelFramer({children, className} : ModelFramerProps) {

  return (
    <motion.div
          variants={{
            hidden: { opacity: 0, scale: 0.95 },
            visible: { opacity: 1, scale: 1 },
            exit: { opacity: 0, scale: 0.95 },
          }}
          initial="hidden"
          animate="visible"
          exit="exit"
          transition={{
            duration: 0.4,
            ease: "easeInOut",
          }}
          className={className}
        >
        {children}
      </motion.div>
  )
}
